var map = {
	"./app.data.json": 15,
	"./career.data.json": 89,
	"./experience.data.json": 55,
	"./footer.data.json": 17,
	"./home.data.json": 46,
	"./imprint.data.json": 255,
	"./jets.data.json": 32,
	"./privacy-policy.data.json": 256,
	"./seo.data.json": 57,
	"./sponsoring.data.json": 58,
	"./story.data.json": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 254;